import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseAccount, ResponseAccountDto } from '../types/dtos';
import { APP_ENDPOINTS } from '../../../app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<ResponseAccountDto, BaseAccount>({
        query: (payload) => ({
            url: APP_ENDPOINTS.ACCOUNTS,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [],
    });
